import React, { memo } from 'react'
import {
    Grid,
    Box,
    Typography,
    Backdrop,
    CircularProgress,
    styled,
} from '@mui/material'
import { CustomBackdropProps } from './CustomBackdrop.types'

const StyleBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.common.white,
}))

function CustomBackdrop({ open, children, message }: CustomBackdropProps) {
    return (
        <StyleBackdrop open={open}>
            <Grid item xs={12}>
                {children ? (
                    children
                ) : (
                    <Grid container justifyContent="center">
                        <Grid item xs="auto">
                            <Box pb={2}>
                                <CircularProgress color="inherit" />
                            </Box>
                        </Grid>
                    </Grid>
                )}
                {message && (
                    <Grid container justifyContent="center">
                        <Grid item xs={12}>
                            <Typography
                                variant="body1"
                                component="h6"
                                align="center"
                            >
                                {message}
                            </Typography>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </StyleBackdrop>
    )
}

export default memo(CustomBackdrop)
